<div class="action-tablet-transport-creation-profile-details" (click)="createPlannedTransportFromProfile()">
    <sc-padding [double]="true">
        <sc-flex [centered]="true">
            {{transportCreationProfile?.displayName}}
        </sc-flex>
    </sc-padding>
    <app-service-response [responseMessages]="responseMessages"></app-service-response>
</div>
